import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetDaysToShip = (dateFrom: Date, dateTo: Date) => {
    const { data, isLoading } = useQuery({
        queryKey: ['days-to-ship', dateFrom, dateTo],
        queryFn: async () => await apiClient.get('purchase-order/days-to-ship',
            {
                params: {
                    dateFrom,
                    dateTo
                }
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
